import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-template-2',
  imports: [CommonModule],
  templateUrl: './modal-template-2.component.html',
  styleUrl: './modal-template-2.component.css'
})
export class ModalTemplate2Component {
  @Input() title: string = '';       // ✅ ชื่อหัว modal
  @Input() leftButton: boolean = true;
  @Input() rightButton: boolean = true;
  @Input() disableLeftButton: boolean = false;
  @Input() disableRightButton: boolean = false;
  @Input() leftText: string = 'ตกลง';  // ✅ ข้อความปุ่มยกเลิก
  @Input() rightText: string = 'ปิด'; // ✅ ข้อความปุ่มยืนยัน
  @Input() leftButtonColor : string = ''; // ✅ สีปุ่มยกเลิก
  @Input() rightButtonColor : string = ''; // ✅ สีปุ่มยืนยัน
  @Input() leftTextColor : string  = ''; // ✅ สีข้อความปุ่มยกเลิก
  @Input() rightTextColor : string  = ''; // ✅ สีข้อความปุ่มยืนยัน
  @Output() left = new EventEmitter<void>();  // ✅ ออก event เมื่อกดปิด
  @Output() right = new EventEmitter<void>(); // ✅ ออก event เมื่อกดยืนยัน
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
  onLeft() {
    this.left.emit();
  }

  onRight() {
    this.right.emit();
  }
}
